module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagecontent"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticStyle: {
      "height": "30px",
      "margin-top": "20px",
      "padding-left": "16px"
    }
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/home'
      }
    }
  }, [_vm._v("首頁")]), _vm._v(" "), _c('el-breadcrumb-item', {
    staticClass: "breadTitleColor",
    attrs: {
      "to": {
        path: '/lectureroom'
      }
    }
  }, [_vm._v("影音報恩講堂")]), _vm._v(" "), _c('el-breadcrumb-item', {
    staticClass: "breadTitleColor"
  }, [_vm._v(_vm._s(_vm.breadTitle))])], 1)], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 4,
      "lg": 4,
      "xl": 4
    }
  }, [_c('div', {
    staticClass: "left-content"
  }, [_c('el-image', {
    attrs: {
      "src": _vm.leftImage,
      "fit": "contain"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "title-box"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('span', {
    staticClass: "up"
  }, [_vm._v("報恩講堂")]), _vm._v(" "), _c('span', {
    staticClass: "down"
  }, [_vm._v("Dharma Talks")])])]), _vm._v(" "), _c('el-tree', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.baoenTree.code == 1),
      expression: "baoenTree.code ==1"
    }],
    staticClass: "tree",
    staticStyle: {
      "font-size": "1.8rem"
    },
    attrs: {
      "highlight-current": true,
      "data": _vm.baoenTree.categories,
      "props": _vm.myTreeProps
    },
    on: {
      "node-click": _vm.handleNodeClick
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": {
        push: 1,
        span: 19
      },
      "lg": {
        push: 1,
        span: 19
      },
      "xl": {
        push: 1,
        span: 19
      }
    }
  }, [(_vm.topspeechShow) ? _c('el-row', [_c('el-col', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.baoenTree.code == 1),
      expression: "baoenTree.code ==1 "
    }],
    staticClass: "title-div"
  }, [_vm._v(_vm._s(_vm.topspeech.name))])])], 1) : _vm._e(), _vm._v(" "), (_vm.topspeechShow) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "topspeechList"
  }, [_c('el-row', _vm._l((_vm.topspeech.data), function(item) {
    return _c('el-col', {
      key: item.id,
      attrs: {
        "xs": 24,
        "sm": 24,
        "md": 6,
        "lg": 6,
        "xl": 6,
        "data-item": "item"
      }
    }, [_c('card', {
      attrs: {
        "cardInfo": item,
        "url": _vm.topurl,
        "preUrl": _vm.preUrl
      }
    })], 1)
  }), 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "update-div"
  }, [(_vm.topspeechShow) ? _c('span', [_vm._v("最近更新:")]) : _c('span', [_vm._v(_vm._s(_vm.baoenTree.category === undefined ? '' : _vm.baoenTree.category.AMTB_NAME))])])])], 1), _vm._v(" "), (_vm.topspeechShow) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.baoenTree.code == 1),
      expression: "baoenTree.code ==1 "
    }],
    staticClass: "right-table",
    attrs: {
      "row-class-name": "rowstyle",
      "data": _vm.recentspeech
    },
    on: {
      "row-click": _vm.rowClickLatestUpdates
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "250",
      "fixed": "",
      "label": "講題",
      "prop": "title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "集數",
      "prop": "numdesc"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "編號",
      "prop": "itemid",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "地點",
      "show-overflow-tooltip": true,
      "prop": "speechplace",
      "width": "150"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "update-div"
  }, [(_vm.topspeechShow) ? _c('span', [_vm._v("熱門影音:")]) : _c('span', [_vm._v(_vm._s(_vm.baoenTree.category === undefined ? '' : _vm.baoenTree.category.AMTB_NAME))])])])], 1), _vm._v(" "), (_vm.topspeechShow) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.baoenTree.code == 1),
      expression: "baoenTree.code ==1 "
    }],
    staticClass: "right-table",
    attrs: {
      "row-class-name": "rowstyle",
      "data": _vm.hotspeech
    },
    on: {
      "row-click": _vm.hotRowClickLatestUpdates
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "250",
      "fixed": "",
      "label": "講題",
      "prop": "title"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "集數",
      "prop": "numbers"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "編號",
      "prop": "menuid",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "地點",
      "show-overflow-tooltip": true,
      "prop": "speechplace",
      "width": "150"
    }
  })], 1)], 1)], 1) : _c('el-row', [_c('el-col', [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.selectRadio),
      callback: function($$v) {
        _vm.selectRadio = $$v
      },
      expression: "selectRadio"
    }
  }, [_vm._v("列表式")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.selectRadio),
      callback: function($$v) {
        _vm.selectRadio = $$v
      },
      expression: "selectRadio"
    }
  }, [_vm._v("棋盤式")])], 1), _vm._v(" "), (_vm.selectRadio == 1) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.baoenloading),
      expression: "baoenloading"
    }],
    staticClass: "right-table",
    attrs: {
      "data": _vm.baoenCategoryList.data,
      "row-class-name": "rowstyle"
    },
    on: {
      "sort-change": _vm.clickSort,
      "row-click": _vm.rowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "150",
      "fixed": "",
      "label": "講題",
      "prop": "titlealt",
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "日期",
      "sortable": "custom",
      "prop": "speechdate",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "總集數",
      "sortable": "custom",
      "prop": "numbers",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "地點",
      "show-overflow-tooltip": true,
      "prop": "speechplace",
      "sortable": "custom",
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "編號",
      "sortable": "custom",
      "prop": "menuid"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "音頻",
      "prop": "mp3",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary",
            "disable-transitions": ""
          }
        }, [_vm._v(_vm._s(scope.row.mp3 == 1 ? '有' : '無'))])]
      }
    }], null, false, 3746161893)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "視頻",
      "prop": "mp4",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary",
            "disable-transitions": ""
          }
        }, [_vm._v(_vm._s(scope.row.mp4 == 1 ? '有' : '無'))])]
      }
    }], null, false, 298842498)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "高清視頻",
      "prop": "himp4",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary",
            "disable-transitions": ""
          }
        }, [_vm._v(_vm._s(scope.row.himp4 == 1 ? '有' : '無'))])]
      }
    }], null, false, 2666841667)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文字",
      "prop": "txt",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary",
            "disable-transitions": ""
          }
        }, [_vm._v(_vm._s(scope.row.txt == 1 ? '有' : '無'))])]
      }
    }], null, false, 1228810739)
  })], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.baoenCategoryList.data), function(item) {
    return (_vm.selectRadio == 2) ? _c('el-col', {
      key: item.id,
      attrs: {
        "span": 24,
        "xs": 24,
        "sm": 24,
        "md": 6,
        "lg": 6,
        "xl": 6,
        "data-item": "item"
      }
    }, [_c('playcard', {
      ref: "playcard",
      refInFor: true,
      attrs: {
        "cardInfo": item,
        "url": _vm.topurl,
        "preUrl": _vm.preUrl
      },
      on: {
        "playcardClick": _vm.playcardClick
      }
    })], 1) : _vm._e()
  })], 2), _vm._v(" "), (!_vm.topspeechShow) ? _c('el-row', [_c('br')]) : _vm._e(), _vm._v(" "), (!_vm.topspeechShow) ? _c('el-row', [_c('br')]) : _vm._e(), _vm._v(" "), (!_vm.topspeechShow) ? _c('el-row', [_c('br')]) : _vm._e(), _vm._v(" "), (!_vm.topspeechShow) ? _c('el-row', [_c('br')]) : _vm._e(), _vm._v(" "), (!_vm.topspeechShow) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": _vm.layoutStyle,
      "page-size": 20,
      "pager-count": _vm.pageCount,
      "background": "",
      "small": "",
      "current-page": _vm.currentPage,
      "total": _vm.baoenCategoryList.total - 0
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      },
      "current-change": _vm.pagechange,
      "prev-click": _vm.preclick,
      "next-click": _vm.nextclick
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "search-div"
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "17px",
      "font-weight": "bold"
    }
  }, [_vm._v("搜尋講演關鍵字:")])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('memoryrecent', {
    ref: "parentMemoryRencentRef",
    attrs: {
      "id": "searchInputId",
      "placeholderkeyword": _vm.placeholderkeyword
    },
    on: {
      "search-mbBlur": _vm.searchBlur,
      "search-mbBtn": _vm.queryList
    }
  })], 1)], 1)], 1)])], 1), _vm._v(" "), (_vm.clickQuery) ? _c('el-row', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.queryloading),
      expression: "queryloading"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "17px",
      "font-weight": "bold"
    }
  }, [_vm._v("      搜尋結果：")]), _vm._v(" "), _c('el-table', {
    staticClass: "right-table",
    attrs: {
      "stripe": true,
      "data": _vm.baoenQueryList,
      "row-class-name": "rowstyle"
    },
    on: {
      "sort-change": _vm.clickSortQuery,
      "row-click": _vm.queryrowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "120",
      "fixed": "",
      "label": "講題",
      "sortable": "custom",
      "prop": "titlealt"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "日期",
      "sortable": "custom",
      "prop": "speechdate"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "總集數",
      "sortable": "custom",
      "prop": "numbers",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "150",
      "label": "地點",
      "sortable": "custom",
      "show-overflow-tooltip": true,
      "prop": "speechplace"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "100",
      "label": "編號",
      "sortable": "custom",
      "prop": "menuid"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "音頻",
      "prop": "mp3",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary",
            "disable-transitions": ""
          }
        }, [_vm._v(_vm._s(scope.row.mp3 == 1 ? '有' : '無'))])]
      }
    }], null, false, 3746161893)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "視頻",
      "prop": "mp4",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary",
            "disable-transitions": ""
          }
        }, [_vm._v(_vm._s(scope.row.mp4 == 1 ? '有' : '無'))])]
      }
    }], null, false, 298842498)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "高清視頻",
      "prop": "himp4",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary",
            "disable-transitions": ""
          }
        }, [_vm._v(_vm._s(scope.row.himp4 == 1 ? '有' : '無'))])]
      }
    }], null, false, 2666841667)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文字",
      "prop": "txt",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": "primary",
            "disable-transitions": ""
          }
        }, [_vm._v(_vm._s(scope.row.txt == 1 ? '有' : '無'))])]
      }
    }], null, false, 1228810739)
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.clickQuery) ? _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": _vm.layoutStyle,
      "page-size": 20,
      "pager-count": _vm.pageCount,
      "background": "",
      "small": "",
      "current-page": _vm.currentPageSearch,
      "total": _vm.baoenQueryListSize
    },
    on: {
      "update:currentPage": function($event) {
        _vm.currentPageSearch = $event
      },
      "update:current-page": function($event) {
        _vm.currentPageSearch = $event
      },
      "current-change": _vm.pagechangeSearch,
      "prev-click": _vm.preclickSearch,
      "next-click": _vm.nextclickSearch
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', [_c('div', {
    staticClass: "search-div"
  }, [_c('el-row', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('span', {
    staticStyle: {
      "width": "45rem",
      "padding-bottom": "2rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.ftpstatement)
    }
  }, [_vm._v("搜尋講演關鍵字:")])])], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-104bf64a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/Videozhibo/lectureroom.vue
// module id = 1048
// module chunks = 5